import React, { type FC } from 'react'
import { checkboxClasses, type Components, SvgIcon, svgIconClasses, type SvgIconProps, type Theme } from '@mui/material'

const CheckboxIndeterminateIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="CheckboxIndeterminateIcon" viewBox="0 0 16 16" fill="none" {...props}>
        <rect width="16" height="16" rx="2" fill="currentColor" />
        <path fill="none" d="M5 8H11" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
)

const CheckboxUncheckedIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="CheckboxUncheckedIcon" viewBox="0 0 16 16" {...props}>
        <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" fill="white" />
        <rect fill="none" x="0.5" y="0.5" width="15" height="15" rx="1.5" stroke="currentColor" strokeWidth="1" />
    </SvgIcon>
)

const CheckboxCheckedIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="CheckboxCheckedIcon" viewBox="0 0 16 16" fill="none" {...props}>
        <rect width="16" height="16" rx="2" fill="currentColor" />
        <path fill="none" d="M12 5L6.5 10.5L4 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
)

/**
 * Note: the `color` prop is not respected — colors are fixed by the design.
 */
export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
    defaultProps: {
        disableRipple: true,
        icon: <CheckboxUncheckedIcon />,
        checkedIcon: <CheckboxCheckedIcon />,
        indeterminateIcon: <CheckboxIndeterminateIcon />,
    },
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.grey[300],
            '&:hover': {
                backgroundColor: 'unset',
            },
            [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
                color: theme.palette.primary[700],
            },
            // Focus
            '&.Mui-focusVisible': {
                [`& .${svgIconClasses.root}`]: {
                    outline: `2px solid ${theme.palette.primary[700]}`,
                    outlineOffset: 1,
                    borderRadius: 1,
                },
            },
            // Disabled
            [`&.${checkboxClasses.disabled}`]: {
                color: theme.palette.grey[200],
            },
        }),
        sizeSmall: {
            [`& .${svgIconClasses.root}`]: {
                fontSize: 16,
            },
        },
        sizeMedium: {
            [`& .${svgIconClasses.root}`]: {
                fontSize: 20,
            },
        },
    },
}
